import { Card, Flex, Text } from "@mantine/core";
import { client_selected } from "../../../../client";
import { useTranslation } from "react-i18next";

interface IProps {
  header: React.ReactNode;
  children?: React.ReactNode;
  onClick: () => void;
  image?: string;
  title?: string;
}

export default function ComponentNewCardSpider({
  onClick,
  header,
  children,
  image,
  title,
}: IProps) {
  const { t } = useTranslation();
  return (
    <Card
      onClick={onClick}
      withBorder
      p={5}
      miw={"100%"}
      mih={322}
      sx={(theme) => ({
        textDecoration: "none",
        cursor: "pointer",
        transition: "all 0.5s ease-in-out",
        borderRadius: "12px",
        boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.05)",
        overflow: "hidden",
        background: "white",
        border: "1px solid #D7D7D7",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "5px",
        ":hover": {
          button: {
            color: theme.colors.basic[0],
            borderColor: theme.colors.primary[1],
            background: theme.colors.primary[1],
          },
        },
      })}
    >
      <Flex h={"254px"} w="100%" style={{ position: "relative", zIndex: 1 }}>
        <Flex
          h="100%"
          w="100%"
          justify="center"
          align="center"
          style={{
            zIndex: 0,
            position: "absolute",
            overflow: "hidden",
            borderRadius: "10px",
          }}
        >
          <img
            src={!!image ? image : client_selected.image.logo2}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: !!image ? "cover" : "fill",
              zIndex: 0,
              filter: "brightness(0.8)",
            }}
          />
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: 1,
              background:
                "linear-gradient(180.2deg, rgba(0, 0, 0, 0) 0%, rgba(14, 16, 28, 0.20) 35%, #191C33 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
            }}
          />
        </Flex>
        <Flex
          w="100%"
          h={"244px"}
          direction={"column"}
          justify="space-between"
          style={{ position: "relative", zIndex: 1 }}
        >
          {header}
        </Flex>
      </Flex>
      {children}
    </Card>
  );
}
